import { Route } from '@angular/router';

import {
  authGuard,
  loyaltyGuard,
  noAuthGuard,
  venuesGuard,
} from '@shared/data-access/guards';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@shared/login').then((m) => m.LoginFeatureComponent),
    canActivate: [noAuthGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('../shell/ionic-shell/ionic-shell.component').then(
        (m) => m.IonicShellComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: 'room-reservations',
        loadComponent: () =>
          import(
            '@shared/reservations/reservations-feature/reservations-feature/reservations-feature-ionic.component'
          ).then((m) => m.ReservationsFeatureIonicComponent),
      },
      {
        path: 'room-reservations/:reservationId',
        loadComponent: () =>
          import(
            '@shared/reservations/reservation-details-feature/reservation-details-feature/reservation-details-feature-ionic.component'
          ).then((m) => m.ReservationDetailsFeatureIonicIonicComponent),
      },
      {
        path: 'profiles',
        loadComponent: () =>
          import(
            '@shared/profiles/profiles-feature/profiles-feature/profiles-feature-ionic.component'
          ).then((m) => m.ProfilesFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/quick-view',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-quick-view-feature/profile-quick-view/profile-quick-view-ionic.component'
          ).then((m) => m.ProfileQuickViewFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/details',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-details-feature/profile-details-feature/profile-details-feature-ionic.component'
          ).then((m) => m.ProfileDetailsFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/preferences',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-preferences-feature/profile-preferences-feature/profile-preferences-feature-ionic.component'
          ).then((m) => m.ProfilePreferencesFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/consents',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-consents-feature/profile-consents-feature/profile-consents-feature-ionic.component'
          ).then((m) => m.ProfileConsentsFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/room-reservations',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-hotel-reservations-feature/profile-hotel-reservations-feature/profile-hotel-reservations-feature-ionic.component'
          ).then((m) => m.ProfileHotelReservationsFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/venue-reservations',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-venue-reservations-feature/profile-venue-reservations-feature/profile-venue-reservations-feature-ionic.component'
          ).then((m) => m.ProfileVenueReservationsFeatureIonicComponent),
      },
      {
        path: 'profiles/:profileId/loyalty',
        loadComponent: () =>
          import(
            '@shared/profiles/profile-loyalty-feature/profile-loyalty-feature/profile-loyalty-feature-ionic.component'
          ).then((m) => m.ProfileLoyaltyFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-feature/loyalty-feature/loyalty-feature-ionic.component'
          ).then((m) => m.LoyaltyFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId',
        pathMatch: 'full',
        redirectTo: 'loyalty/:profileId/quick-view',
      },
      {
        path: 'loyalty/:profileId/quick-view',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-quick-view-feature/loyalty-quick-view-feature-ionic.component'
          ).then((m) => m.LoyaltyQuickViewFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId/ffp',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-ffp-feature/loyalty-ffp-feature-ionic.component'
          ).then((m) => m.LoyaltyFfpFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId/points',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-points-feature/loyalty-points-feature-ionic.component'
          ).then((m) => m.LoyaltyPointsFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId/attributes',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-attributes-feature/loyalty-attributes-feature-ionic.component'
          ).then((m) => m.LoyaltyAttributesFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId/vouchers',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-vouchers-feature/loyalty-vouchers-feature-ionic.component'
          ).then((m) => m.LoyaltyVouchersFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'loyalty/:profileId/point-history',
        loadComponent: () =>
          import(
            '@shared/loyalty/loyalty-details-feature/loyalty-point-history-feature/loyalty-point-history-feature-ionic.component'
          ).then((m) => m.LoyaltyPointHistoryFeatureIonicComponent),
        canActivate: [loyaltyGuard],
      },
      {
        path: 'venue-reservations',
        loadComponent: () =>
          import(
            '@shared/venue-reservations/venue-reservations-feature/venue-reservations-feature/venue-reservations-feature-ionic.component'
          ).then((m) => m.VenueReservationsFeatureIonicComponent),
        canActivate: [venuesGuard],
      },
      {
        path: 'venue-reservations/:reservationId',
        loadComponent: () =>
          import(
            '@shared/venue-reservations/venue-reservation-details-feature/venue-reservation-details-feature/venue-reservation-details-feature-ionic.component'
          ).then((m) => m.VenueReservationDetailsFeatureIonicComponent),
        canActivate: [venuesGuard],
      },
      {
        path: 'app-settings',
        loadComponent: () =>
          import('../shell/app-settings/app-settings.component').then(
            (m) => m.AppSettingsComponent,
          ),
      },
    ],
  },
];
